<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-24 11:46:03
 * @LastEditTime: 2019-10-09 21:34:28
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="addStore">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="基础信息" name="1">
        <el-form ref="form" :rules="rules" :model="form" label-width="110px">
          <el-form-item label="经销商编号" prop="dealer_sn">
            <el-input v-model="form.dealer_sn "></el-input>
          </el-form-item>
          <el-form-item label="经销商名称" prop="dealer_name">
            <el-input v-model="form.dealer_name "></el-input>
          </el-form-item>

          <el-form-item label="经销商地址:" prop="address">
            <el-select v-model="form.country" placeholder="国" clearable style="margin-right:10px" @change='getprovinces()'>
              <el-option v-for=" i in countrys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.province" placeholder="省" clearable style="margin-right:10px" @change='getcity()'>
              <el-option v-for=" i in provinces" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.city" placeholder="市" clearable style="margin-right:10px" @change='getArea()'>
              <el-option v-for=" i in citys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.area" placeholder="区" clearable style="margin-right:10px" @change='$forceUpdate()'>
              <el-option v-for=" i in areas" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" 1" class="label">
            <el-input type="textarea" v-model="form.detail" placeholder="请输入内容"></el-input>
          </el-form-item>

          <el-form-item label="销售区域:" prop="address">
            <el-row style="display:flex;">
              <div style='display: flex;flex-direction: column'>
                <el-select v-model="country2" placeholder="国" clearable style="margin-right:10px;margin-bottom:20px;" @change='getprovinces2()'>
                  <el-option v-for=" i in countrys2" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
                </el-select>
                <el-select v-model="province2" placeholder="省" clearable style="margin-right:10px;margin-bottom:20px;" @change='getcity2()'>
                  <el-option v-for=" i in provinces2" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
                </el-select>
                <el-select v-model="city2" placeholder="市" clearable style="margin-right:10px;margin-bottom:20px;" @change='getArea2()'>
                  <el-option v-for=" i in citys2" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
                </el-select>
                <el-select v-model="area2" placeholder="区" clearable style="margin-right:10px;margin-bottom:20px;" @change='$forceUpdate()'>
                  <el-option v-for=" i in areas2" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
                </el-select>
              </div>

              <div>
                <el-button type="primary" style='margin:0 auto;margin-right:10px;' @click='addadress()'>添加</el-button>

              </div>
              <div>
                <div class='areaBox'>
                  <ul>
                    <li v-for='(value,index ) in areaText' :key='index'> <span>{{value}}</span><span class='' @click='delArea'>x</span></li>
                  </ul>
                </div>

              </div>
            </el-row>
          </el-form-item>

          <el-form-item label="经销商负责人" prop="person">
            <el-input v-model="form.person" placeholder="请输入经销商负责人"></el-input>
          </el-form-item>
          <el-form-item label="经销商级别:" prop="level_id">
            <el-select v-model="form.level_id" placeholder="经销商类型" clearable>
              <el-option v-for=" i in storeList" :key="i.id" :label="i.lname" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="form.mobile " placeholder="请输入手机号"></el-input>
            <div style=''>

            </div>
          </el-form-item>

          <el-form-item label="密码" prop="password" v-if='!$route.query.edit'>
            <el-input v-model="form.password" placeholder="请输入密码" type='password'></el-input>
          </el-form-item>
          <el-form-item label="所属区域:">
            <el-select v-model="form.region_country" placeholder="国" clearable style="margin-right:10px" @change='getregionprovinces()'>
              <el-option v-for=" i in region_countrys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.region_province" placeholder="省" clearable style="margin-right:10px" @change='getregioncity()'>
              <el-option v-for=" i in region_provinces" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.region_city" placeholder="市" clearable style="margin-right:10px" @change='getregionArea()'>
              <el-option v-for=" i in region_citys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
            <el-select v-model="form.region_area" placeholder="区" clearable style="margin-right:10px" @change='$forceUpdate()'>
              <el-option v-for=" i in region_areas" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="拓展信息" name="2">
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder></el-input>

          </el-form-item>
          <el-form-item label="微信号" prop="phone">
            <el-input v-model="form.weixin" placeholder></el-input>

          </el-form-item>
          <el-form-item label="qq" prop="phone">
            <el-input v-model="form.qq" placeholder></el-input>

          </el-form-item>
          <el-form-item label="邮箱" prop="phone">
            <el-input v-model="form.email" placeholder></el-input>

          </el-form-item>
          <el-form-item label="专卖信息" prop="phone">
            <el-input v-model="form.zmsg" placeholder></el-input>

          </el-form-item>
          <el-form-item label="经销商简介:">
            <el-input type="textarea" v-model="form.msg" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <Bmap v-if="getGps" @confirm='confirm' @handleClose="close()"></Bmap>
    <div class="btns">
      <!-- <el-button type="primary" style='margin:0 auto;' @click='add()' v-if='$route.query.edit'>保存</el-button> -->

      <el-button type="primary" style='margin:0 auto;' @click='add()'>保存</el-button>

    </div>
  </div>
</template>

<script>
import Bmap from "@/common/Bmap/Bmap.vue";
import { setTimeout } from "timers";
import { fips } from "crypto";
export default {
  name: "addStore",
  data() {
    return {
      imageUrl: false,
      getGps: false,
      activeNames: "1",
      storeList: [],
      form: {
        detail: "",
        gps: "",

        person: "",

        password: "",
        from_level_id: "",
        price: "",

        imageUrl: [],
      },
      areaText: [],
      delete: [],
      is_delete_img: "0",
      delete_img: [],
      rules: {
        dealer_sn: [
          { required: true, message: "请输入经销商编号", trigger: "blur" },
        ],
        gps: [{ required: true, message: "请选择gps", trigger: "change" }],
        img_url: [
          { required: true, message: "请选择经销商图片", trigger: "blur" },
        ],
        person: [
          { required: true, message: "请输入经销商负责人", trigger: "blur" },
        ],
        storename: [
          { required: true, message: "请填写活动形式", trigger: "blur" },
        ],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        dealer_name: [
          { required: true, message: "请输入经销商名称", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        level_id: [
          { required: true, message: "请选择经销商级别", trigger: "change" },
        ],
      },
      dealerLevel: [],
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
      countrys2: [],
      provinces2: [],
      citys2: [],
      areas2: [],
      region_areas: [],
      region_countrys: [],
      region_provinces: [],
      region_citys: [],
      country2: "",
      province2: "",
      city2: "",
      area2: "",
      region: [],
      regionsTemp: [], //存放 上级已选区域
      dealer_area: [], //存放 所属区域
    };
  },
  methods: {
    init() {
      this.getGps = true;
      setTimeout(() => {
        this.getGps = false;
      }, 200);
    },
    //  获取上级 经销商 的区域
    getRegionsList() {
      this.$get("logistics_2", "vstore/dealer_pc/region", {
        type: 5,
      })
        .then((res) => {
          this.regionsTemp = res.data.sale;
          this.dealer_area = res.data.region;
        })
        .catch((error) => {});
    },
    isEdit() {
      if (this.$route.query.edit) {
        this.$get("logistics_2", "/vstore/dealer_pc/dealerdetail", {
          id: this.$route.query.edit,
        }).then((res) => {
          this.form = res.data;

          delete this.form["parent_dealer_id"];
          console.log(this.form);
          this.getcountry();

          this.getprovinces("edit");
          this.getcity("edit");
          this.getArea("edit");

          this.getregioncountry("edit");
          this.getregionprovinces("edit");
          this.getregioncity("edit");
          this.getregionArea("edit");

          this.form.region.forEach((element) => {
            this.areaText.push(element.address);
            this.region.push(element.id);
          });
        });
      }
    },
    // 获取四级联动
    getcountry(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 1,
        })
          .then((res) => {
            this.countrys = res.data;
          })
          .catch((error) => {});
      } else {
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 1,
        })
          .then((res) => {
            this.countrys = res.data;
            this.citys = [];
            this.areas = [];
            this.provinces = [];
          })
          .catch((error) => {});
      }
    },
    getprovinces(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.country,
        })
          .then((res) => {
            this.provinces = res.data;
          })
          .catch((error) => {});
      } else {
        this.citys = [];
        this.provinces = [];
        this.areas = [];
        this.form.province = "";
        this.form.city = "";
        this.form.area = "";

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.country,
        })
          .then((res) => {
            this.provinces = res.data;
          })
          .catch((error) => {});
      }
    },
    getcity(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.province,
        })
          .then((res) => {
            this.citys = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.citys = [];
        this.areas = [];
        this.form.city = "";
        this.form.area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.province,
        })
          .then((res) => {
            this.citys = res.data;
          })
          .catch((error) => {});
      }
    },
    getArea(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.city,
        })
          .then((res) => {
            this.areas = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.areas = [];
        this.form.area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.city,
        })
          .then((res) => {
            this.areas = res.data;
          })
          .catch((error) => {});
      }
    },

    // 获取四级联动
    getregioncountry(temp) {
      var flag = temp || false;
      if (flag) {
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 1,
          parent_id: "",
        })
          .then((res) => {
            this.region_countrys = res.data;
          })
          .catch((error) => {});
      } else {
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 1,
          parent_id: "",
        })
          .then((res) => {
            this.region_countrys = res.data;
            this.region_citys = [];
            this.region_areas = [];
            this.region_provinces = [];
          })
          .catch((error) => {});
      }
    },
    getregionprovinces(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 2,
          parent_id: this.form.region_country,
        })
          .then((res) => {
            this.region_provinces = res.data;
          })
          .catch((error) => {});
      } else {
        this.region_citys = [];
        this.region_provinces = [];
        this.region_areas = [];
        this.form.region_province = "";
        this.form.region_city = "";
        this.form.region_area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 2,
          parent_id: this.form.region_country,
        })
          .then((res) => {
            this.region_provinces = res.data;
          })
          .catch((error) => {});
      }
    },
    getregioncity(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 3,
          parent_id: this.form.region_province,
        })
          .then((res) => {
            this.region_citys = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.region_citys = [];
        this.region_areas = [];
        this.form.region_city = "";
        this.form.region_area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 3,
          parent_id: this.form.region_province,
        })
          .then((res) => {
            this.region_citys = res.data;
          })
          .catch((error) => {});
      }
    },
    getregionArea(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 4,
          parent_id: this.form.region_city,
        })
          .then((res) => {
            this.region_areas = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.region_areas = [];
        this.form.region_area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
          type: 4,
          parent_id: this.form.region_city,
        })
          .then((res) => {
            this.region_areas = res.data;
          })
          .catch((error) => {});
      }
    },

    getcountry2(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 1,
        })
          .then((res) => {
            this.countrys2 = res.data;
          })
          .catch((error) => {});
      } else {
        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 1,
        })
          .then((res) => {
            this.countrys2 = res.data;
            this.citys2 = [];
            this.areas2 = [];
            this.provinces2 = [];
          })
          .catch((error) => {});
      }
    },
    getprovinces2(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 2,
          parent_id: this.country2,
        })
          .then((res) => {
            this.provinces2 = res.data;
          })
          .catch((error) => {});
      } else {
        this.citys2 = [];
        this.provinces2 = [];
        this.areas2 = [];
        this.province2 = "";
        this.city2 = "";
        this.area2 = "";

        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 2,
          parent_id: this.country2,
        })
          .then((res) => {
            this.provinces2 = res.data;
          })
          .catch((error) => {});
      }
    },
    getcity2(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 3,
          parent_id: this.province2,
        })
          .then((res) => {
            this.citys2 = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.citys2 = [];
        this.areas2 = [];
        this.city2 = "";
        this.area2 = "";
        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 3,
          parent_id: this.province2,
        })
          .then((res) => {
            this.citys2 = res.data;
          })
          .catch((error) => {});
      }
    },
    getArea2(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 4,
          parent_id: this.city2,
        })
          .then((res) => {
            this.areas2 = res.data;
          })
          .catch((error) => {});
      } else {
        this.$forceUpdate();
        this.areas2 = [];
        this.area2 = "";
        this.$get("logistics_2", "/vstore/dealer_pc/region", {
          type: 4,
          parent_id: this.city2,
        })
          .then((res) => {
            this.areas2 = res.data;
          })
          .catch((error) => {});
      }
    },

    getStoreLevel() {
      this.$get("logistics_2", "/vstore/dealer_pc/dealerlevel")
        .then((res) => {
          this.storeList = res.data;
        })
        .catch((error) => {});
    },

    addadress() {
      var text = "";
      if (this.country2 == "") {
        this.$message({
          type: "error",
          message: "请选择国家",
        });
        return;
      }
      var ids = [];
      this.countrys2.forEach((element) => {
        if (element.region_id == this.country2) {
          text += element.region_name + "";
          ids.push(element.region_id);
        }
      });

      if (this.province2 != "") {
        this.provinces2.forEach((element) => {
          if (element.region_id == this.province2) {
            text += element.region_name + "";
            ids.push(element.region_id);
          }
        });
      } else {
        ids.push(0);
      }
      if (this.city2 != "") {
        this.citys2.forEach((element) => {
          if (element.region_id == this.city2) {
            text += element.region_name + "";
            ids.push(element.region_id);
          }
        });
      } else {
        ids.push(0);
      }
      if (this.area2 != "") {
        this.areas2.forEach((element) => {
          if (element.region_id == this.area2) {
            text += element.region_name;
            ids.push(element.region_id);
          }
        });
      } else {
        ids.push(0);
      }
      // 创建一个flag  判断是否有 不一样
      var tempflag = true;
      var temp = this.regionsTemp; //销售区域    数组每一项都为 字符串数组
      for (let i = 0; i < temp.length; i++) {
        //  把数组迭代  把undefined 替换 为0方便计算
        temp[i] = temp[i].replace("undefined", "0");
        // 再循环数组每一项的 字符串数组
        // 每次循环都是新的初始化 falg
        tempflag = true;
        for (var k = 0; k < temp[i].split(",").length; k++) {
          //  当为0 或者 最后一位不为0的时候 则是 当前数组的 有效数据范畴  （0为空） 进而使用 有效数据进行比对
          if (
            temp[i].split(",")[k - 1] != "0" &&
            temp[i].split(",")[k] == 0 &&
            temp[i].split(",")[3] == "0"
          ) {
            // 存再一种可能 没有0
            if (
              k == 3 &&
              temp[i].split(",")[3] != ids[3] &&
              temp[i].split(",")[3] != "0"
            ) {
              tempflag = false;
              //  console.log(ids,temp[i],k)
              break;
            }
            for (var j = 0; j < k; j++) {
              if (temp[i].split(",")[j] != ids[j]) {
                tempflag = false;
              }
            }
          }
          if (temp[i].split(",")[3] != "0") {
            for (var j = 0; j < k; j++) {
              if (temp[i].split(",")[j] != ids[j]) {
                tempflag = false;
              }
            }
          }
        }
        // 当该次循环 没有错误则可以return
        if (tempflag) {
          break;
        }
      }
      if (!tempflag) {
        this.$message({
          type: "error",
          message: "添加的销售区域范围不能大于自己！",
        });
        return;
      }
      var flag = true;
      if (this.region.length) {
        this.region.forEach((element) => {
          var temp = element;
          if (
            (temp.split(",")[2] == ids[2] && temp.split(",")[3] == 0) ||
            (temp.split(",")[2] == ids[2] && ids[3] == 0)
          ) {
            if (flag) {
              this.$message({
                type: "error",
                message: "亲,销售地区不能重复或重叠,请重新选择",
              });
            }
            flag = false;
          }
        });
      } else {
        this.areaText.push(text);
        this.region.push(ids.join(","));
        flag = false;
      }
      if (flag) {
        this.areaText.push(text);
        this.region.push(ids.join(","));
      }
    },
    delArea(index) {
      this.areaText.splice(index, 1);
      this.region.splice(index, 1);
    },
    add() {
      if (this.form.country == "") {
        this.$message({
          type: "error",
          message: "请选择国家",
        });
        return;
      }
      // console.log(this.form)
      var ids = [
        this.form.region_country ? this.form.region_country : 0,
        this.form.region_province ? this.form.region_province : 0,
        this.form.region_city ? this.form.region_city : 0,
        this.form.region_area ? this.form.region_area : 0,
      ];
      //  return;

      // 创建一个flag  判断是否有 不一样
      var tempflag = true;
      var temp = this.dealer_area; //所属区域    数组每一项都为 字符串数组
      for (let i = 0; i < temp.length; i++) {
        //  把数组迭代  把undefined 替换 为0方便计算
        temp[i] = temp[i].replace("undefined", "0");
        // 再循环数组每一项的 字符串数组
        // 每次循环都是新的初始化 falg
        tempflag = true;

        for (var k = 0; k < temp[i].split(",").length; k++) {
          //  当为0 或者 最后一位不为0的时候 则是 当前数组的 有效数据范畴  （0为空） 进而使用 有效数据进行比对
          if (
            temp[i].split(",")[k - 1] != "0" &&
            temp[i].split(",")[k] == 0 &&
            temp[i].split(",")[3] == "0"
          ) {
            console.log(temp[i], k);
            // 存再一种可能 没有0
            if (
              k == 3 &&
              temp[i].split(",")[3] != ids[3] &&
              temp[i].split(",")[3] != "0"
            ) {
              tempflag = false;
              //  console.log(ids,temp[i],k)
              break;
            }
            for (var j = 0; j < k; j++) {
              if (temp[i].split(",")[j] != ids[j]) {
                console.log(temp[i], ids, k);
                tempflag = false;
              }
            }
          }
          if (temp[i].split(",")[3] != "0") {
            for (var j = 0; j < k; j++) {
              if (temp[i].split(",")[j] != ids[j]) {
                tempflag = false;
              }
            }
          }
        }
        // 当该次循环 没有错误则可以return
        if (tempflag) {
          break;
        }
      }
      if (!tempflag) {
        this.$message({
          type: "error",
          message: "添加的所属区域范围不能大于自己！",
        });
        return;
      }

      this.$refs["form"].validate((valid) => {
        if (valid) {
          // this.form.parent_dealer_id = this.form.level_id
          // this.form.from_level_id=this.form.level_id
          if (this.$route.query.edit) {
            this.$post("logistics_2", "vstore/dealer_pc/editdealer", {
              ...this.form,
              set_password: "0",
              region: this.region,
            }).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "成功",
                });
                this.$router.push({
                  name: "next_leve",
                });
              }
            });
          } else {
            this.$post("logistics_2", "vstore/dealer_pc/adddealer", {
              ...this.form,
              region: this.region,
            }).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "成功",
                });
                this.$router.push({
                  name: "next_leve",
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    close() {
      this.getGps = false;
    },
    GPS() {
      this.getGps = !this.getGps;
    },
    confirm(value) {
      this.getGps = false;
      this.form.gps = value.point.lng + "," + value.point.lat;
    },
  },
  created() {
    this.getRegionsList();
    this.getStoreLevel();
    this.getcountry();
    this.getregioncountry();
    this.isEdit();
    this.getcountry2();
  },
  components: {
    Bmap,
  },
};
</script>
<style lang="scss" scoped>
.addStore {
  background-color: #fff;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  /deep/.el-collapse-item__header {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
    // background-color: rgb(242, 242, 242);
  }
  /deep/.el-collapse-item__content {
    padding: 30px 100px;
  }
  /deep/.el-input {
    width: auto;
    width: 250px;
    margin-right: 10px;
  }
  /deep/.el-form-item__label {
    // width: 95px !important;
  }
  /deep/.el-textarea {
    width: 500px;
    height: 200px;
    .el-textarea__inner {
      height: 100%;
    }
  }
  .label {
    /deep/.el-form-item__label {
      //   width: 95px !important;
      color: #fff;
    }
  }
  .avatar-uploader {
    display: inline-block;
    border: 1px dashed #eee;
  }
  .avatar-uploader .el-upload {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .tips {
    display: inline-block;
    width: 250px;
    color: #333;
    vertical-align: middle;
    margin-left: 10px;
  }
}
.avatar-uploader {
  float: left;
  margin-right: 10px;
}
.imgList {
  float: left;
  width: 180px;
  height: 180px;
  margin-right: 10px;
  position: relative;
  img {
    width: 100%;
  }
  span {
    display: inline-block;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    bottom: 0;
    right: 0;
    left: 0;
    position: absolute;
    padding: 15px 0;
    display: none;
    i {
      float: right;
      margin-right: 20px;
      font-size: 15px;
    }
  }
}

.imgList:hover span {
  display: block;
}
.btns {
  text-align: center;
  padding-top: 20px;
}
/deep/.el-collapse {
  border-bottom: none;
}
.areaBox {
  width: 178px;
  border: 1px solid #eee;
  height: 178px;
  overflow-y: scroll;
  ul {
    width: 100%;
    li {
      height: 40px;
      padding: 0 10px;
      span:first-child {
        float: left;
      }
      span:last-child {
        float: right;
        cursor: pointer;
      }
    }
    li:hover {
      background-color: #eee;
    }
  }
}
</style>


